import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { planLimitsFromRow, type PlanLimitsRow } from '@/lib/plan-limits';

// The generated Supabase types don't include this RPC yet.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const db = supabase as any;

/**
 * The plan limits that apply to a business right now, from the
 * org_plan_limits RPC (the same rules the database enforces). Any member of
 * the business can read them. Resolves to null when they can't be read, so the
 * UI falls back to today's behaviour and the database stays the backstop.
 */
export function useOrgPlanLimits(orgId: string | null | undefined) {
  return useQuery({
    queryKey: ['org-plan-limits', orgId],
    enabled: Boolean(orgId),
    staleTime: 30_000,
    queryFn: async () => {
      const { data, error } = await db.rpc('org_plan_limits', { _org: orgId });
      if (error) {
        console.warn('Could not read plan limits', error);
        return null;
      }
      const row = (Array.isArray(data) ? data[0] : data) as PlanLimitsRow | undefined;
      return row ? planLimitsFromRow(row) : null;
    },
  });
}
